import { Result } from 'designed';
import m from 'mixpanel-browser';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addContext = (data: Record<string, any>) => {
  Result.fromThrowable(() => {
    m.register(data);
  });
};
